import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

// Membership Attendance
import MembershipAttendance from '../programs/memberAttendance/memberAttendance';

/* < ---- Programs ---- > */

import AddNewProgram from '../../pages/programs/addNewProgram/addNewProgram';
import EditProgram from '../../pages/programs/editProgram/editProgram';
import ProgramDetails from '../../pages/programs/programDetails/programDetails';
import ProgramRegistration from '../../pages/programs/programRegistration/programRegistration';
import AddAttendance from '../../pages/programs/addAttendance/addAttendance';


import ProgramsList from '../programs/programsList/programsList';
import ProgramsHistory from '../programs/programsHistory/programsHistory';

// Registration List
import RegistrationList from '../programs/registrationList/registrationList';

// Registration Details
import RegistrationDetails from '../programs/registrationDetails/registrationDetails';

// Attendance List
import AddNewAttendance from '../programs/addNewAttendance/addNewAttendance';
import CreateAttendance from '../programs/createAttendanceWithoutRegistration/createAttendanceWithoutRegistration';
import EditAttendance from '../programs/editAttendance/editAttendance';
import AttendanceListDetails from '../programs/attendanceListDetails/attendanceListDetails';

import WaitingListPayment from '../../pages/programs/waitingListPayment/waitingListPayment';

// Submitted Attendance list
import SubmitedAttendances from '../programs/submitedAttendances/submitedAttendances';

import Dashboard from '../dashboard/dashboard';

// settings
import ProfileSettings from '../profile/profile';

const ProgramAdminRoutes = function(userData) {
  return (
    <Switch>
      {/* Dashboard */}
      <Route path="/adminPortal/dashboard/:tab?" render={(props) => <Dashboard {...props} userData={userData} />} />

      {/* Programs Routes */}
      <Route path="/adminPortal/programs/waitingList/registration/:programID/:waitingListID/:membershipID/:step?" render={(props) => <WaitingListPayment {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/registrationDetails/:programID/:membershipID/:familyMemberID" render={(props) => <RegistrationDetails {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/memberProgramAttendance/:membershipID/:programID" component={MembershipAttendance} />
      <Route path="/adminPortal/programs/attendanceListDetails/:attendanceListDate/:programID" render={(props) => <AttendanceListDetails {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/addNewAttendance/:programID" component={AddNewAttendance} />
      <Route path="/adminPortal/programs/submitedAttendances/:programID" component={SubmitedAttendances} />
      <Route path="/adminPortal/programs/editProgram/:programID" component={EditProgram} />
      <Route path="/adminPortal/programs/createattendance/:programID" render={(props) => <CreateAttendance {...props} userData={userData} />}/>
      <Route path="/adminPortal/programs/editattendance/:programID/:attendeenceID" render={(props) => <EditAttendance {...props} userData={userData} />}/>
      <Route path="/adminPortal/programs/registrationList/:programID" render={(props) => <RegistrationList {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/programRegistration/:programID/:backPage?" render={(props) => <ProgramRegistration {...props} userData={userData} />} />
       <Route path="/adminPortal/programs/AddAttendance/:programID/:backPage?" render={(props) => <AddAttendance {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/programDetails/:programID" render={(props) => <ProgramDetails {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/addNewProgram/programInformation" component={AddNewProgram} />
      <Route path="/adminPortal/programs/history" render={(props) => <ProgramsHistory {...props} userData={userData} />} />
      <Route path="/adminPortal/programs/*" render={(props) => <ProgramsList {...props} userData={userData} />} />

      {/* Profile */}
      <Route path="/adminPortal/profile" render={(props) => <ProfileSettings {...props} userData={userData} />} />

      <Route path="*" exact render={(props) => <ProgramsList {...props} userData={userData} />} />
    </Switch>
  );
};

export default ProgramAdminRoutes;

ProgramAdminRoutes.propTypes = {
  userData: PropTypes.shape({
    userType: PropTypes.string,
  }).isRequired,
};
